import {selectConstructionPlanBrushToken} from "../../../../redux/reducers/privateStateReducer/selectors";
import {checkIfConstructionPlanningAvailable} from "./getConstructionPlanContext";
import {resolveConstructionPlanPlacement} from "./buildConstructionPlanningViewState";
import {CONSTRUCTION_PLACEMENT_KINDS} from "../resolveConstructionPlacement";

export const CONSTRUCTION_PLANNING_CLICK_ACTIONS = {
  // Запланировать выбранное строение на ячейке
  ADD: 'add',
  // Показать, почему здесь строить нельзя (тот же тост, что у клика в свой ход)
  TOAST: 'toast',
  // Клик не про план — обычная инспекция ячейки
  INSPECT: 'inspect',
};

/**
 * Что делает одинарный клик по полю при планировании строительства (чужой ход
 * фазы строительства, свой в ней еще впереди) — как клик в свой ход:
 *  1. выбранное для плана строение можно поставить на ячейку — ставим в план
 *     (в том числе спецстроение на запланированный квартал);
 *  2. иначе строить здесь нельзя — тост с причиной;
 *  3. иначе (строение не выбрано, ячейка вне подсвеченных) — инспекция.
 * Снять запланированное одинарный клик не может: как и постройку своего хода,
 * его снимает двойной клик (findConstructionPlanUndo, GameScene) или кнопка
 * отмены. Иначе клик, которым строение поверх не встало (например, не хватило
 * монет на спецстроение), молча снимал бы запланированное под ним.
 */
export const decideConstructionPlanningClick = (state, hexKey) => {
  if (!checkIfConstructionPlanningAvailable(state)) {
    return {type: CONSTRUCTION_PLANNING_CLICK_ACTIONS.INSPECT};
  }

  const brushToken = selectConstructionPlanBrushToken(state);
  if (!brushToken) {
    return {type: CONSTRUCTION_PLANNING_CLICK_ACTIONS.INSPECT};
  }

  const placement = resolveConstructionPlanPlacement(state, hexKey, brushToken);
  if (placement.kind === CONSTRUCTION_PLACEMENT_KINDS.COMMON || placement.kind === CONSTRUCTION_PLACEMENT_KINDS.SPECIAL) {
    // Цена — для звука постановки: он такой же, как у настоящей стройки,
    // вместе со звоном монет (см. playBuildingPlacement)
    return {
      type: CONSTRUCTION_PLANNING_CLICK_ACTIONS.ADD,
      token: brushToken,
      priceCoins: placement.priceCoins,
    };
  }
  if (placement.kind === CONSTRUCTION_PLACEMENT_KINDS.ERROR) {
    return {type: CONSTRUCTION_PLANNING_CLICK_ACTIONS.TOAST, message: placement.errorMessage};
  }
  return {type: CONSTRUCTION_PLANNING_CLICK_ACTIONS.INSPECT};
};
